import axios from 'axios';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Стратегии регистрации из настроек проекта (yz_api_settings.registration).
const REGISTRATION = {
  unregisteredByPhone: 'unregistered_by_phone',
  existingByPhone: 'existing_by_phone',
  freeByPhone: 'free_by_phone',
  freeByEmail: 'free_by_email',
};

// Типы токена подтверждения — совпадают с Token::TYPE_* на бэкенде.
const TOKEN_TYPE = {
  smsNoprofileOrUnregistered: 'sms_noprofile_or_unregistered',
  smsProfileUnregistered: 'sms_profile_unregistered',
  smsNoprofile: 'sms_noprofile',
  emailNoprofile: 'email_noprofile',
};

const REGISTER_INFO_URL = 'profiles/api/register/info';
const REGISTER_URL = 'profiles/api/register';

// ТЗ: текст для профиля, ещё не подтверждённого Руководителем отдела
// (совпадает с RegisterExistingByPhoneForm::PROFILE_UNDER_REVIEW_MESSAGE).
const PROFILE_UNDER_REVIEW_MESSAGE = 'Данные вашего профиля на согласовании. Обратитесь к вашему менеджеру.';

// Начальное состояние формы участника — единый источник для data() и Reset().
const defaultUser = () => ({
  phone: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  email: '',
  password: '',
  passwordConfirm: '',
  role: 'seller',
  inn: '',
  type: '',
  companyName: '',
  factAddress: '',
  checkedRules: false,
  checkedPers: false,
});

export default {
  data() {
    return {
      user: defaultUser(),
      types: ['ООО', 'ИП'],
      sameAddresses: true,
      company: null,
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        // ТЗ пароль по сложности не регламентирует; держим фронт в паре с бэкендом
        // (RegisterExistingByPhoneForm: password min 6). Пустое отдаём rules.required.
        password: v => (!v || v.length >= 6) || 'Пароль должен быть не менее 6 символов',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        inn: v => (!v || !v.length || !this.user.type
          || v.length >= (this.user.type === 'ООО' ? 10 : 12)) || 'ИНН заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
      valid: false,
      profile: {},
      genders: [
        {
          name: 'Мужской',
          value: 'male',
        },
        {
          name: 'Женский',
          value: 'female',
        },
      ],
      suggestions: [],
      address_data: null,
    };
  },
  watch: {
    'user.inn': function (val) {
      if (val && val.length >= 10) {
        this.$store.getters.axl.post('profiles/api/dealers/find-by-inn', {inn_search: val, type_id: 1})
          .then((result) => {
            const company = result.data.data[0];
            if (company) {
              this.company = company;
              this.user.companyName = company.organization_name;
            }
          })
          .catch((error) => {
            this.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === REGISTRATION.unregisteredByPhone) {
        return TOKEN_TYPE.smsNoprofileOrUnregistered;
      }
      if (this.$store.state.settings.registration === REGISTRATION.existingByPhone) {
        return TOKEN_TYPE.smsProfileUnregistered;
      }
      if (this.$store.state.settings.registration === REGISTRATION.freeByPhone) {
        return TOKEN_TYPE.smsNoprofile;
      }
      if (this.settings && this.settings.registration === REGISTRATION.freeByEmail) {
        return TOKEN_TYPE.emailNoprofile;
      }
      return null;
    },
    isSmsUnregistared() {
      return this.type === TOKEN_TYPE.smsNoprofileOrUnregistered;
    },
    isSmsNoProfile() {
      return this.type === TOKEN_TYPE.smsProfileUnregistered;
    },
    isEmailNoProfile() {
      return this.type === TOKEN_TYPE.emailNoprofile;
    },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    /** Запрос данных для регистрации (без индикатора загрузки) */
    FetchRegInfo(payload) {
      return this.$store.getters.ax.post(REGISTER_INFO_URL, payload);
    },
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      // Токен обязателен: бэкенд отдаёт блок profile только по валидному,
      // привязанному к телефону токену (защита register/info от перебора номеров).
      app.FetchRegInfo({phone: app.user.phone, token: app.token})
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const {profile} = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id)?.focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = defaultUser();
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;

      this.Focus('regPhone');
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = {type: app.type};
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/get-sms';
        data.phone = app.user.phone;
        // ТЗ: профиль на согласовании у Руководителя не начинает регистрацию —
        // сообщаем проактивно, до отправки СМС; бэкенд-гейт get-sms остаётся
        // второй линией с тем же текстом, поэтому сбой info не блокирует flow.
        // Токен тут не нужен (интересуют только found/underReview).
        app.FetchRegInfo({phone: app.user.phone})
          .then((response) => {
            if (response.data.underReview === true) {
              app.$store.dispatch('ShowError', PROFILE_UNDER_REVIEW_MESSAGE);
              app.Focus('regPhone');
              return;
            }
            app.PostSendCode(url, data);
          })
          .catch(() => app.PostSendCode(url, data));
        return;
      }
      app.PostSendCode(url, data);
    },
    /** Собственно запрос кода подтверждения */
    PostSendCode(url, data) {
      const app = this;
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = {type: app.type, code: app.code};
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = {...app.user};
      formData.token = app.token;
      formData.legalForm = app.user.type;
      delete formData.type;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl.post(REGISTER_URL, formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = {count: 20, query: queryString};
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
        }
      });
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
  },
};
